import { render, staticRenderFns } from "./RepoList.vue?vue&type=template&id=71f1c057&"
import script from "./RepoList.vue?vue&type=script&lang=js&"
export * from "./RepoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports